import React from 'react';
import Field from "./../field";
import Grid from '@material-ui/core/Grid';
import {withTranslation} from "react-i18next";

class FieldNestedSingleEntity extends React.Component {
    constructor(props) {
        super(props);
        const {defaultValue} = this.props;
        this.state = {
            typeSelected: defaultValue
                ? (typeof defaultValue['type_selected'] === 'number'
                    ? Number(defaultValue['type_selected'])
                    : defaultValue['type_selected'])
                : 0,
        };
    };
    handleChange = (e) => {
        const {state} = this;
        const value = e.target.value;
        this.setState({...state, typeSelected: typeof value === 'number' ? Number(value) : value})
    };
    render() {
        const {name, scheme, defaultValue, refs, i18n} = this.props;
        const {typeSelected} = this.state;
        const {handleChange} = this;
        let options = [];
        Object.keys(scheme.type.element_fields).map(elementField => {
            const el = scheme.type.element_fields[elementField];
            const value = i18n.language === 'en' && el.label_en ? el.label_en : el.label;
            options.push({
                id: elementField,
                value: value,
            });
        });
        refs[name] = {};
        refs[name]['values'] = {};

        const isLabelEn = i18n.language === 'en' && scheme.label_en
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Field
                                name={'type_selected'}
                                scheme={{
                                    label: isLabelEn ? scheme.label_en : scheme.label,
                                    required: scheme.required,
                                    type: {data_source: 'inner', format: 'single_select', values: options}
                                }}
                                defaultValue={typeSelected}
                                refs={refs[name]}
                                onChange={handleChange} />
                        </Grid>
                        {typeSelected
                            ? Object.keys(scheme.type.element_fields[typeSelected].type.element_fields).map(elementField => {
                                return (
                                    <Grid item xs={12} key={elementField}>
                                        <Field
                                            name={elementField}
                                            scheme={scheme.type.element_fields[typeSelected].type.element_fields[elementField]}
                                            defaultValue={defaultValue ? defaultValue['values'][elementField] : undefined}
                                            refs={refs[name]['values']} />
                                    </Grid>
                                )
                            })
                            : null}
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}
export default withTranslation()(FieldNestedSingleEntity);